import { addHours } from 'date-fns'
import { Showing } from '../../types/showings'
import { isInFuture } from '../dates'

/** if not reserved, 2hr limit for reserving. Reserved openShowing can be reserved with no time limit
 *
 * 4hr limit for creating showings
 * If openHouse with reservations/applictionIdList
 *
 * If you want all future showings and don't care about time limit for reservation, boolean is false
 */
const getFutureShowings = (
  showings: Showing[],
  timeLimitForShowing: 'reserve' | 'create' | false,
  ignoreWithReservedApplicationId = ''
) =>
  showings.filter(({ startDate, applicationIds }: Showing) => {
    if (
      ignoreWithReservedApplicationId &&
      Array.isArray(applicationIds) &&
      applicationIds.includes(ignoreWithReservedApplicationId)
    ) {
      return true
    }
    let delayBy = 0
    if (timeLimitForShowing === 'reserve') {
      delayBy = applicationIds ? 0 : 2
    }
    if (timeLimitForShowing === 'create') {
      delayBy = applicationIds ? 0 : 4
    }
    const currentDatePlusDelay = addHours(new Date(), delayBy).valueOf()
    return isInFuture(Date.parse(startDate), currentDatePlusDelay)
  })

export { getFutureShowings }
